import React from 'react';
import { Colors, Spacing } from 'works/legacy/lib/style-helper';

const colorSet = {
  default: {
    backgroundColor: Colors.white,
    borderColor: Colors.steel,
  },
  blue: {
    backgroundColor: Colors.skyHyperLight,
    borderColor: Colors.skyLighter,
  },
  transparent: {
    backgroundColor: 'transparent',
    borderColor: Colors.steel,
  },
};

/**
 * @deprecated: Use the Card component instead
 */
export const DeprecatedCard = ({
  children,
  color = 'default',
  className = '',
  padding,
  borderColor,
  backgroundColor,
  ...other
}: React.PropsWithChildren<{
  color?: 'default' | 'blue' | 'transparent';
  className?: string;
  padding?: string;
  backgroundColor?: string;
  borderColor?: string;
}>) => {
  const paddingClass = padding ? `padding-${padding}` : '';

  return (
    <>
      <div className={`Card ${paddingClass} ${className}`} {...other}>
        {children}
      </div>
      <style jsx>{`
        .Card {
          border: 1px solid ${borderColor || colorSet[color].borderColor};
          box-shadow: 0px 1px 3px rgba(18, 81, 91, 0.15);
          border-radius: 4px;
          padding: ${Spacing.baseSpacingPx};
          background-color: ${backgroundColor ||
          colorSet[color].backgroundColor};
        }
        .Card.padding-narrow {
          padding: ${Spacing.baseSpacing / 2}px;
        }
      `}</style>
    </>
  );
};
